import React from 'react';
import { motion } from 'framer-motion';
import ArrowIcon from "../../assets/icons/ArrowIconBlue.svg";

const Button2 = ({ children, onClick, width }) => {
  return (
    <motion.button
      onClick={onClick}
      whileTap={{ scale: 0.95 }}
      whileHover={{ scale: 1.03 }}
      transition={{ type: 'spring', stiffness: 300, damping: 20 }}
      className="px-2 pl-5 py-2 flex items-center justify-between text-white font-semibold rounded-full"
      style={{
        width: width || 'auto',
        background: 'linear-gradient(102.87deg, #256EEF 46.28%, #00FFAE 166.92%)',
        borderRadius: '50px',
      }}
    >
      <span className="mr-3">{children}</span>
      <div className="bg-white w-fit p-2 rounded-full flex items-center justify-center">
        <img src={ArrowIcon} className="w-4 h-4" alt="arrow" />
      </div>
    </motion.button>
  );
};

export default Button2;
